'use client';

import { c as _c } from "react/compiler-runtime";
import { throttle } from 'lodash';
import { type ReactNode, useEffect, useMemo, useRef, useState } from 'react';
import { useBreakpoints } from '@src/utils/breakpoints.util';
import { CUSTOM_EVENTS } from '@src/utils/constants.util';
import { cn } from '@src/utils/tailwind';
import { Container } from '../Container/Container';
const SCROLL_THRESHOLD_DEFAULT = 20;
export interface StickyFooterProps {
  previewMode?: boolean;
  scrollThresholdDesktop?: number;
  scrollThresholdMobile?: number;
  attributes?: any;
  children?: ReactNode;
  useTargetElement?: boolean;
  targetElement?: string;
  className?: string;
}
export const StickyFooter = t0 => {
  const $ = _c(17);
  const {
    previewMode,
    scrollThresholdDesktop,
    scrollThresholdMobile,
    attributes,
    children,
    useTargetElement: t1,
    targetElement: t2,
    className
  } = t0;
  const useTargetElement = t1 === undefined ? false : t1;
  const targetElement = t2 === undefined ? "" : t2;
  const [isVisible, setVisible] = useState(false);
  const prevVisibleRef = useRef(isVisible);
  const {
    isMobile
  } = useBreakpoints();
  const scrollThreshold = (isMobile ? scrollThresholdMobile : scrollThresholdDesktop) ?? SCROLL_THRESHOLD_DEFAULT;
  let t3;
  let t4;
  if ($[0] !== scrollThreshold || $[1] !== targetElement || $[2] !== useTargetElement) {
    t3 = () => {
      const onScroll = throttle(() => {
        if (useTargetElement) {
          const el = document.querySelector(targetElement);
          if (el) {
            const rect = el.getBoundingClientRect();
            const isOutOfTop = rect.bottom < 0;
            setVisible(isOutOfTop);
          }
        } else {
          setVisible(window.scrollY > scrollThreshold);
        }
      }, 300);
      window.addEventListener("scroll", onScroll);
      return () => {
        window.removeEventListener("scroll", onScroll);
      };
    };
    t4 = [scrollThreshold, targetElement, useTargetElement];
    $[0] = scrollThreshold;
    $[1] = targetElement;
    $[2] = useTargetElement;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[5] !== isVisible) {
    t5 = () => {
      if (prevVisibleRef.current !== isVisible) {
        const eventName = isVisible ? CUSTOM_EVENTS.stickyFooterVisible : CUSTOM_EVENTS.stickyFooterHidden;
        window.dispatchEvent(new CustomEvent(eventName));
        prevVisibleRef.current = isVisible;
      }
    };
    t6 = [isVisible];
    $[5] = isVisible;
    $[6] = t5;
    $[7] = t6;
  } else {
    t5 = $[6];
    t6 = $[7];
  }
  useEffect(t5, t6);
  const t7 = attributes?.className;
  const t8 = isVisible || previewMode;
  let t9;
  if ($[8] !== className || $[9] !== t7 || $[10] !== t8) {
    t9 = cn("fixed bottom-0 left-0 z-10 flex min-h-[100px] w-full translate-y-full items-center bg-bodi-black-text py-5 text-white transition-all lg:py-8", t7, className, {
      "translate-y-0": t8
    });
    $[8] = className;
    $[9] = t7;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== children) {
    t10 = <Container>{children}</Container>;
    $[12] = children;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t9) {
    t11 = <div className={t9}>{t10}</div>;
    $[14] = t10;
    $[15] = t9;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  return t11;
};